import React from 'react';

export const Invoice = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 46 47">
      <path
        stroke="#20446A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.896"
        d="M8.438 1.959l14.329 8.277-5.216 9.029a.948.948 0 01-1.295.346L2.75 11.81a.948.948 0 01-.347-1.295l4.742-8.208a.948.948 0 011.294-.347zm14.328 26.338l-1.841 5.919a.947.947 0 01-1.187.624l-9.559-2.973a.948.948 0 01-.624-1.187l1.559-5.012a.948.948 0 011.185-.624l10.467 3.253zM43.21 17.153L30.53 27.1a.948.948 0 01-1.33-.16l-6.437-8.205L36.188 8.203a.948.948 0 011.331.161l5.852 7.458a.948.948 0 01-.161 1.33z"
        clipRule="evenodd"
      ></path>
      <path
        stroke="#20446A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.896"
        d="M22.766 39.62V3.6"
      ></path>
      <path
        stroke="#20446A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.896"
        d="M9.846 10.491a2.37 2.37 0 104.74 0 2.37 2.37 0 00-4.74 0h0zm20.837 7.237a2.37 2.37 0 104.74 0 2.37 2.37 0 00-4.74 0z"
        clipRule="evenodd"
      ></path>
      <path
        stroke="#20446A"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.896"
        d="M17.184 45.308l-1.473-4.44a.948.948 0 01.9-1.247h12.536a.948.948 0 01.9 1.247l-1.48 4.44"
      ></path>
    </svg>
  );
};
